export class SupplierDashboardBiddingSessionsStats {
	public numAllSessions: number;
	public numPinnedSessions: number;
	public numClosingSoonSessions: number;
	public numActiveSessions: number;
	public numNewSessions: number;
	public numSessionsWon: number;
	public numClosedSessions: number;

	constructor(supplierDashboardBiddingSessionsStats: SupplierDashboardBiddingSessionsStats) {
		Object.assign(this, supplierDashboardBiddingSessionsStats);
	}
}
